import React, { FC } from 'react'
import cx from 'classnames'
import styles from './Heading.module.scss'

export type HeadingSizes = 'main' | 'secondary' | 'card' | 'widget'

type HeadingProps = {
  size?: HeadingSizes
  weight?: 'regular' | 'weak'
  align?: 'left' | 'right' | 'center'
  truncate?: boolean
  component?: keyof JSX.IntrinsicElements
  className?: string
}

export const Heading: FC<HeadingProps> = ({
  align = 'left',
  children,
  component: HeadingComponent = 'h1',
  size = 'main',
  truncate,
  weight = 'regular',
  className = '',
  ...other
}) => {
  const classes = cx({
    [styles.heading]: true,
    [styles.truncate]: truncate,
    [styles[align]]: align,
    [styles[weight]]: weight,
    [styles[size]]: size,
    [className]: className,
  })

  return (
    <HeadingComponent className={classes} {...other}>
      {children}
    </HeadingComponent>
  )
}

Heading.displayName = 'Heading'
